import { Box, styled } from "@mui/material";

export const IconWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  position: "absolute",
  right: "0.5rem",
  style: { pointerEvents: "none" },
});
